module.exports = __webpack_public_path__ + "static/flags/GL-201819621cc12a17bf73dff3a02af1d5.gif";